import React, { FC } from 'react'

import styles from './styles/Wrapper.module.css'

const Wrapper: FC = ({ children }) => {
  return <div className={styles.view}>{children}</div>
}

export default Wrapper
